import { ACTIONS } from './states';
export const reducer = (pluginState, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_DIFF_OBJECTS:
      return {
        ...pluginState,
        ...action.data
      };
    case ACTIONS.CLEAR_CHANGED_PARAGRAPH_FROM_POSITIONS:
      return {
        ...pluginState,
        changedParagraphFromPositions: []
      };
    case ACTIONS.TOGGLE_SPELLING_AND_GRAMMAR_ENABLED:
      return {
        ...pluginState,
        isSpellingAndGrammarEnabled: !pluginState.isSpellingAndGrammarEnabled
      };
    default:
      return pluginState;
  }
};